import { schema } from 'normalizr'

export const business = new schema.Entity('business', {}, { idAttribute: '_id' })
export const businessArray = new schema.Array(business)
